import { GridPosition } from '@finxone-platform/shared/sys-config-types';

import { calendarWidgetConfig } from '../../../../widgets/profile/profile.type';
import { createBackButtonWidget, createTextWidget } from '../utils/common-utils';

export const bankStatementsCustomDateRangeWidgets = [
  createTextWidget({
    text: '<h1>Pick Start & End Dates</h1>',
    configDisplayName: 'Text Widget: Pick Start & End Dates',
    gridPosition: { y: 1, rows: 3 },
    css_config: {
      color: 'var(--color-on-background)',
      textAlignment: 'center',
      fontSize: 10,
      isTextBold: true,
    },
  }),
  calendarWidgetConfig,
  createBackButtonWidget({ y: 25, rows: 2, cols: 7 } as GridPosition),
];
